import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'
import type {BioIconProps} from '../../icons/common-types'

export default function TopReviews24Logo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold tablet:gap-1 tablet:text-base">
      <svg width="29" height="36" viewBox="0 0 29 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.5"
          d="M22.3075 3.375C26.0036 3.375 28.9998 6.39708 28.9998 10.125C28.9998 13.8529 26.0036 16.875 22.3075 16.875H15.6152L15.6152 10.125C15.6152 6.39708 18.6115 3.375 22.3075 3.375Z"
          fill="white"
        />
        <path
          d="M0 10.125C0 6.39708 2.99625 3.375 6.69231 3.375C10.3884 3.375 13.3846 6.39708 13.3846 10.125V16.875H6.69231C2.99625 16.875 0 13.8529 0 10.125Z"
          fill="white"
        />
        <path
          d="M6.69231 32.625C2.99625 32.625 -4.40724e-08 29.6029 0 25.875C4.40778e-08 22.1471 2.99625 19.125 6.69231 19.125H13.3846V25.875C13.3846 29.6029 10.3884 32.625 6.69231 32.625Z"
          fill="white"
        />
        <path
          d="M29 25.875C29 29.6029 26.0038 32.625 22.3077 32.625C18.6116 32.625 15.6154 29.6029 15.6154 25.875V19.125L22.3077 19.125C26.0038 19.125 29 22.1471 29 25.875Z"
          fill="white"
        />
      </svg>

      <span>Top Reviews 24</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-7 -top-3 size-9 shrink-0 -rotate-12 tablet:-right-5 tablet:-top-1 tablet:size-6"
      />
    </div>
  )
}
